var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup56(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.334,
    height: 8,
    viewBox: "0 0 14.334 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(523.643 -198.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3470",
    "data-name": "Path 3470",
    d: "M-516.418,204.477a1.43,1.43,0,0,1,.135-.189q2.79-2.794,5.584-5.586a.8.8,0,0,1,1.313.2.786.786,0,0,1-.17.911c-.435.439-.873.874-1.31,1.311l-4.923,4.923a.821.821,0,0,1-1.327,0q-3.123-3.123-6.246-6.247a.8.8,0,0,1,.073-1.274.773.773,0,0,1,1,.084c.268.253.523.518.783.778l4.92,4.927C-516.548,204.357-516.5,204.4-516.418,204.477Z",
    transform: "translate(0 0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup56);
export default __webpack_public_path__ + "static/media/Group 56.cd2dfe5fa185fd5272c3721f6f954828.svg";
export { ForwardRef as ReactComponent };